import { create } from 'zustand'
import { produce } from 'immer'

export const useWhatsapp = create((set) => ({
  data: {
    config: {
      active: false,
      hour: null,
    },
    connection: {
      qrCode: null,
      instanceId: null,
      sessionId: null,
      statusName: 'Indefinido',
      statusCode: 'idle',
      profilePic: null,
      phoneNumber: null,
      profileName: null,
      lastDisconnect: null,
    },
  },
  actions: {
    setConnection: (connection) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.connection = connection;
        }),
      ),
    setConfig: (config) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.config = config;
        }),
      ),
    setActive: (active) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.config.active = active;
        }),
      ),
  },
}))
